/**
 * Small svg action button to split a node into multiple slices.
 */
import React from 'react';

type SliceButtonProps = {
    x: number;
    y: number;
    onClick: () => void;
};

export default function SliceButton({ x, y, onClick }: SliceButtonProps) {
    return (
        <g
            className='svg-button'
            transform={`translate(${x}, 0)`}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            <circle cx={0} cy={y} r={10} fill='#444' />
            <text
                className='svg-button-text'
                x={0}
                y={y - 0.75}
                fill='#fff'
                fontSize={13}
                fontWeight={700}
                textAnchor='middle'
                dominantBaseline='central'
                style={{ fontFamily: 'var(--font-monospace)' }}
            >
                /
            </text>
        </g>
    );
}
